import { render, staticRenderFns } from "./NewsTraining.vue?vue&type=template&id=e24d1b6e&"
import script from "./NewsTraining.vue?vue&type=script&lang=js&"
export * from "./NewsTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports